/* @flow */

// For sorting
export const DESC = 'DESC';
export const ASC = 'ASC';

// For storing the uesrname in local storage
export const STORED_USERNAME_KEY = 'ts_stored_username';

export const TRUSTAR_API_HOST = process.env.TRUSTAR_API_HOST || '';
export const TRUSTAR_WORKFLOWS_LOCALHOST = process.env.TRUSTAR_WORKFLOWS_LOCALHOST || '';

// File types accepted for attaching a report to a TS report
export const ACCEPTED_REPORT_EXTENSIONS = [
  '.doc',
  '.docx',
  '.pdf',
  '.txt',
  '.rtf',
  '.stix',
  '.xml',
  '.html',
  '.json',
  '.csv',
].join(',');


export const MITRE_PREFIX = 'mitre/';


// WEBPACK FOOTER //
// ./web_modules/trustar/utils/constants.js